<section [formGroup]="group" class="flex flex-col justify-center m-auto gap-5">
  <section class="flex justify-center gap-5">
    <mat-form-field>
      <mat-label>Nom</mat-label>
      <input type="text" matInput placeholder="Saisir le nom" formControlName="lastname" ng-pattern="/^[a-zA-Z0-9]*$/" />
      <mat-error *ngIf="lastname.hasError('required')">Vous devez saisir un nom</mat-error>
      <mat-error *ngIf="lastname.hasError('pattern')">Aucun caractère spécial ne doit être présent (#,&,$...)</mat-error>
    </mat-form-field>
    <mat-form-field>
      <mat-label>Prénom</mat-label>
      <input matInput placeholder="Saisir le prénom" formControlName="firstname" ng-pattern="/^[a-zA-Z0-9]*$/"/>
      <mat-error *ngIf="firstname.hasError('required')">Vous devez saisir un prénom</mat-error>
      <mat-error *ngIf="firstname.hasError('pattern')">Aucun caractère spécial ne doit être présent (#,&,$...)</mat-error>
    </mat-form-field>
  </section>
  <section class="flex justify-center gap-5">
    <mat-form-field>
      <mat-label>Fonction</mat-label>
      <input matInput placeholder="Saisir la fonction" formControlName="function" />
    </mat-form-field>
    <mat-form-field>
      <mat-label>Casier</mat-label>
      <input matInput placeholder="Saisir le casier" formControlName="casier" />
    </mat-form-field>
  </section>
  <section class="flex justify-center">
    <mat-form-field id="comment">
      <mat-label>Commentaire</mat-label>
      <textarea matInput placeholder="Saisir un commentaire" mdAutosizeMinRows formControlName="comment"></textarea>
    </mat-form-field>
  </section>
</section>
